import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type FrequencyData } from '../services/frequencyMetaDataService'

/**
 * @fileoverview Redux slice for managing frequency metadata state
 * Handles loading, success, and error states for frequency options
 * @author TIQ Development Team
 * @version 1.0.0
 */

export interface FrequencyMetaDataState {
  isLoading: boolean
  error: string | undefined
  data: FrequencyData | null
  httpStatus: number | undefined
}

export const initialState: FrequencyMetaDataState = {
  isLoading: false,
  error: undefined,
  data: null,
  httpStatus: 0
}

const frequencyMetaDataSlice = createSlice({
  name: 'FrequencyMetaDataSlice',
  initialState,
  reducers: {
    frequencyMetaDataLoadingAction: (state) => {
      return {
        isLoading: true,
        error: undefined,
        data: null,
        httpStatus: 0
      }
    },
    frequencyMetaDataUpdateAction: (state, action: PayloadAction<{ data: FrequencyData, httpStatus: number }>) => {
      return {
        isLoading: false,
        error: undefined,
        data: action.payload.data,
        httpStatus: action.payload.httpStatus
      }
    },
    frequencyMetaDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number | undefined }>) => {
      return {
        isLoading: false,
        error: action.payload.errorMessage,
        data: null,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

export const {
  frequencyMetaDataLoadingAction,
  frequencyMetaDataUpdateAction,
  frequencyMetaDataErrorAction
} = frequencyMetaDataSlice.actions

export default frequencyMetaDataSlice.reducer
